// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__21r6f","amount":"Amount_amount__8qCOk","tip":"Amount_tip__w5_x-","tipHeader":"Amount_tipHeader__1x71x","tipsWrap":"Amount_tipsWrap__VU_sd"};